import { defaultPitch } from './pitch'
import { demonstrationEventTypes } from './events'
import { pitchSetupTypes } from '../../pitches/data_types'
import dataTypes from './data_types_config.json'
import {
  getMetricTypeGroup,
  getMetricTypesConfigFromJson,
  metricTypesConfig
} from '../../metrics/data_types'
export const demonstrationProps = {
  eventTypes: demonstrationEventTypes,
  playerSummaryMetricTypes: getMetricTypeGroup(
    getMetricTypesConfigFromJson(
      dataTypes.playerSummary.metrics,
      metricTypesConfig
    )
  ),
  pitch: {
    default: defaultPitch,
    defaultDoublePitch: null,
    pitchPointCount: 4,
    setupTypes: pitchSetupTypes,
    minPadding2D: 70,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 11,
    enableBench: true,
    enabled2DCameraControls: true,
    leftTeamRegion: {
      topLeft: 'P1',
      topRight: 'P1',
      bottomRight: 'P2',
      bottomLeft: 'P2'
    },
    rightTeamRegion: {
      topLeft: 'P3',
      topRight: 'P3',
      bottomRight: 'P4',
      bottomLeft: 'P4'
    }
  },
  features: {
    targetEvents: [],
    positionNumbers: false,
    maxPlayers: 50,
    defaultUnitSystem: 'SI',
    keyboardShortcuts: {},
    recentEventTableMetrics: [],
    broadcastIntegrationAvailable: false,
    noOfPlayersInStartingLineUp: null,
    scoreboard: false,
    homeSideCheck: false,
    bibs: {},
    disableAsSessionType: true
  } as const
}
